module.exports = __webpack_public_path__ + "img/facebook.87e2de9c.png";